import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  typeName: Yup.string()
    .required('Type Name is required')
    .max(50, 'Maximum length is 50 characters'),
  alarmDelayType: Yup.string().required('Required'),
  alarmDelay: Yup.number()
    .typeError('Alarm delay setting must be a integer')
    .required('Alarm delay setting is required')
    .integer('Alarm delay setting must be a integer'),
  dataType: Yup.string().required('Required'),
  decimalPrecision: Yup.number()
    .typeError('Decimal precision must be a integer')
    .required('Decimal precision is required')
    .integer('Decimal precision must be a integer'),
  units: Yup.string().required('Required'),
  parameter: Yup.string().max(16, 'Maximun character is 16'),
  lossTime: Yup.number()
    .typeError('Comm loss time (min) must be a integer')
    .integer('Comm loss time (min) must be a integer')
    .nullable(),
  //chartMin: Yup.string().test(
  //  'integer-or-decimal',
  //  'Chart min must be a decimal or integer',
  //  (value = '') =>
  //    value.length === 0 ||
  //    value.match(/^\d*\.{1}\d*$/) ||
  //    value.match(/^\d+$/),
  //),
  // .matches(/^\d*\.{1}\d*$/, 'Chart min must be a decimal number')  //  ^[-+]?[0-9]*\.?[0-9]+$
  // .nullable(),
  chartMin: Yup.string().matches(/^[-+]?[0-9]*\.?[0-9]+$/, 'Chart min must be a decimal number')  //  ^[-+]?[0-9]*\.?[0-9]+$
   .nullable(),
 // chartMax: Yup.string().test(
 //   'integer-or-decimal',
 //   'Chart max must be a decimal or integer',
 //   (value = '') =>
 //     value.length === 0 ||
 //     value.match(/^\d*\.{1}\d*$/) ||
 //     value.match(/^\d+$/),
  //),
  // .matches(/^\d*\.{1}\d*$/, 'Chart max must be a decimal number')  //  ^[-+]?[0-9]*\.?[0-9]+$
  // .nullable(),
  chartMax: Yup.string().matches(/^[-+]?[0-9]*\.?[0-9]+$/, 'Chart max must be a decimal number')  //  ^[-+]?[0-9]*\.?[0-9]+$
   .nullable(),
  includeBatch: Yup.boolean(),
  lowAlarmInOperation: Yup.number()
    .typeError('Low alarm must be a number')
    .nullable(),
  lowWarningInOperation: Yup.number()
    .typeError('Low warning must be a number')
    .nullable(),
  highWarningInOperation: Yup.number()
    .typeError('High warning must be a number')
    .nullable(),
  highAlarmInOperation: Yup.number()
    .typeError('High alarm must be a number')
    .nullable(),
  normalLogTimeInOperation: Yup.number()
    .typeError('Normal log time must be a integer')
    .integer('Normal log time must be a integer')
    .nullable(),
  alarmTimeInOperation: Yup.number()
    .typeError('Alarm log time must be a integer')
    .integer('Alarm log time must be a integer')
    .nullable(),
  lowAlarmAtRest: Yup.number()
    .typeError('Low alarm must be a number')
    .nullable(),
  lowWarningAtRest: Yup.number()
    .typeError('Low warning must be a number')
    .nullable(),
  highWarningAtRest: Yup.number()
    .typeError('High warning must be a number')
    .nullable(),
  highAlarmAtRest: Yup.number()
    .typeError('High alarm must be a number')
    .nullable(),
  normalLogTimeAtRest: Yup.number()
    .typeError('Normal log time must be a integer')
    .integer('Normal log time must be a integer')
    .nullable(),
  alarmLogTimeAtRest: Yup.number()
    .typeError('Alarm log time must be a number')
    .integer('Alarm log time must be a number')
    .nullable(),
  chartUnits: Yup.string().required('Calc. units is required'),
  calcDecimalPrecision: Yup.number()
    .typeError('Calc DP must be a integer')
    .required('Calc DP is required')
    .integer('Calc DP must be a integer'),
  //calcChartMin: Yup.string().test(
  //  'integer-or-decimal',
  //  'Calc chart min must be a decimal or integer',
  //  (value = '') =>
  //    value.length === 0 ||
  //    value.match(/^\d*\.{1}\d*$/) ||   //  ^[-+]?[0-9]*\.?[0-9]+$
  //    value.match(/^\d+$/),
  //),
  // calcChartMin: Yup.string().matches(/^\d*\.{1}\d*$/, 'Calc chart min must be a decimal number')
  // .nullable(),
   calcChartMin: Yup.string().matches(/^[-+]?[0-9]*\.?[0-9]+$/, 'Calc chart min must be a decimal number')
   .nullable(),
  //calcChartMax: Yup.string().test(
  //  'integer-or-decimal',
  //  'Calc chart max must be a decimal or integer',
  //  (value = '') =>
  //    value.length === 0 ||
  //    value.match(/^\d*\.{1}\d*$/) ||
  //    value.match(/^\d+$/),
  //),
  // .matches(/^\d*\.{1}\d*$/, 'Calc chart max must be a decimal number')
  // .nullable(),
   calcChartMax: Yup.string().matches(/^[-+]?[0-9]*\.?[0-9]+$/, 'Calc chart max must be a decimal number')
   .nullable(),
});
